<template>
  <div class="mx-auto">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-row no-gutters>
              <v-col cols="12" :md="currStep >= 2 ? 4 : 6">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-office-building-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <span class="caption grey--text">Nama Dinas</span>
                    <div class="subtitle-2 blue--text">
                      {{ $getDeepObj(detail.instansi, 'nama') || '-' }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" :md="currStep >= 2 ? 4 : 6">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <span class="caption grey--text">Operator Dinas Daerah</span>
                    <div class="subtitle-2 blue--text">
                      {{ getOperator(detail) || '-' }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="4" v-if="currStep >= 2">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <span class="caption grey--text">Tanggal Ajuan</span>
                    <div class="subtitle-2 blue--text">
                      {{ $localDate(tahapAjuan.wkt_proses, false, true) || '-' }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
            <stepper
              class="mt-2 mb-3 custom"
              v-if="detail.k_tahap_peringkat_psp > 0"
              :curr-step="detail.k_tahap_peringkat_psp"
            />
            <h3>
              Tahapan Sekarang :
              <span class="blue--text">{{ $getDeepObj(detail.m_tahap_peringkat_psp, 'tahap') || '-' }}</span>
            </h3>
            <v-alert
              icon="mdi-alert"
              colored-border
              class="pa-2 my-2 bg-notif"
              color="warning"
              style="border-width: 0 !important;"
              v-if="detail.k_tahap_peringkat_psp > 1 && $allow('psp-peringkat-verval.reset-tahap')"
            >
              <p class="body-2 mb-0 black--text">
                Anda memiliki wewenang untuk melakukan reset tahapan. Fungsi reset bersifat sekuensial ( berurutan
                terhadap semua kondisi). Tahapan yang direset beresiko menghapus semua data pada tahap tersebut.
              </p>
              <v-btn
                class="mt-2"
                color="error"
                small
                style="text-transform: capitalize"
                depressed
                @click="onReset"
                :disabled="!$allow('psp-peringkat-verval.reset-tahap')"
              >
                <v-icon left dark>
                  mdi-close
                </v-icon>
                Reset Tahapan Dinas
              </v-btn>
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card tile flat class="my-5">
      <v-card-text>
        <v-row>
          <template v-for="(item, t) in tabItems">
            <v-col :key="t" cols="12" md="3" sm="12">
              <v-card
                outlined
                :color="tab === t ? 'green lighten-4' : ''"
                :disabled="item.disabled"
                :style="{ 'border-radius': '5pt', 'border-color': `${item.disabled ? '#CBCBCB' : '#28a745'}` }"
              >
                <v-list-item @click="tab = t">
                  <v-list-item-content>
                    <div
                      :class="['text-center font-weight-medium', item.disabled ? 'grey--text' : 'text-success']"
                      style="align-items: center; justify-content: center"
                    >
                      {{ item.title }}</div
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </template>
        </v-row>
        <v-tabs v-model="tab" fixed-tabs centered>
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            v-show="false"
            :class="['hidden', item.disabled ? 'grey--text' : 'green--text']"
            :disabled="item.disabled"
            v-for="(item, i) in tabItems"
            :key="i"
          >
          </v-tab>
          <v-tab-item class="mt-2" v-for="(item, i) in tabItems" :key="i">
            <component
              ref="tabs"
              :mJenjang="mJenjang"
              :is="item.component"
              :detail="detail"
              @reload="onReload"
              @confirm="onConfirm"
            ></component>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Stepper from '../components/Stepper';
import DetailKandidat from './formulir/Kandidat';
import DetailNilai from './formulir/Peserta';
import DetailPagu from './formulir/Pagu';
import DetailBa from './formulir/Ba';
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    mJenjang: {
      type: Array,
      default: () => [],
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
  },
  components: { Stepper, DetailKandidat, DetailNilai, DetailPagu, DetailBa },
  data() {
    return {
      id: '',
      tab: 2,
      form: {},
      WARNA_STATUS: {
        32: { color: 'orange', icon: 'mdi-check', catatanTeks: 'Catatan' },
        33: { color: 'primary', icon: 'mdi-check', catatanTeks: 'Saran/Solusi' },
        34: { color: '#FF4A4A', icon: 'mdi-close', catatanTeks: 'Catatan untuk Fasilitator Pelapor' },
        35: { color: '#FF7F2A', icon: 'mdi-send', catatanTeks: 'Catatan untuk PMO Pusat' },
        36: { color: 'success', icon: 'mdi-check', catatanTeks: 'Saran/Solusi' },
        37: { color: '#FF4A4A', icon: 'mdi-close', catatanTeks: 'Catatan untuk PMO Dinas' },
      },
    };
  },
  computed: {
    tahapAjuan() {
      const tahaps = this.$getDeepObj(this.detail, 'psp_peringkat_tahaps') || [];
      const filtered = tahaps.filter((item) => item.k_tahap_peringkat_psp === 4);
      const idx = filtered.length - 1;
      return (filtered && filtered[idx]) || {};
    },

    currStep() {
      const tahap = this.detail && this.detail.k_tahap_peringkat_psp;
      const currStep = this.setTab(tahap);
      return currStep;
    },

    tabItems() {
      return [
        { title: 'Verval Data', disabled: false, component: 'DetailKandidat' },
        { title: 'Seleksi Peserta', disabled: this.currStep < 1, component: 'DetailNilai' },
        { title: 'Konfirmasi Pusat', disabled: this.currStep < 2, component: 'DetailPagu' },
        { title: 'Berita Acara', disabled: this.currStep < 3, component: 'DetailBa' },
      ];
    },
  },
  methods: {
    getOperator(data) {
      const tahaps = (data && data.psp_peringkat_tahaps) || [];
      const length = tahaps.length;
      return length ? tahaps[length - 1] && tahaps[length - 1]['akun'] && tahaps[length - 1]['akun']['nama'] : '';
    },
    setTab(value) {
      const mapStep = {
        1: 0,
        2: 0,
        4: 2,
        5: 2,
        6: 2,
        8: 3,
        9: 3,
        10: 3,
      };
      this.tab = mapStep[value];
      return mapStep[value];
    },

    onReload() {
      this.$emit('reload', this.detail);
    },

    onConfirm() {
      this.$emit('confirm', this.detail);
    },

    onReset() {
      this.$emit('reset', this.detail);
    },

    fetchDataChild() {
      this.$nextTick(() => {
        if (this.tab === 0) this.$refs.tabs[this.tab].$refs.kandidat.fetchData();
      });
    },
  },
  watch: {
    currStep: 'setTab',
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.custom > .v-step {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
